const processInclude = require('./util');

$(document).ready(() => {
    processInclude(require('./myaccount/login'));
    processInclude(require('./checkout/leaveCheckoutModal'));
    require('./dataLayer/dataLayer').checkoutEvents();
});
